import { RemovableTag } from '@monash/portal-react';
import cs from '../shared.module.scss';

const CategoryFiltersTags = ({ options, selectedValues, onRemove }) => {
  const flattenedOptions = options.reduce((acc, opt) => {
    const { text, subOptions } = opt;
    const hasSubOptions = Boolean(subOptions);

    if (hasSubOptions) {
      const prefixedSubOptions = subOptions.map((subOpt) => {
        return { ...subOpt, text: `${text} - ${subOpt.text}` };
      });
      return [...acc, opt, ...prefixedSubOptions];
    }
    return [...acc, opt];
  }, []);

  return flattenedOptions
    .filter((opt) => selectedValues?.includes(opt.value))
    .map((opt) => (
      <RemovableTag
        key={opt.value}
        className={cs.tag}
        text={opt.text}
        size="large"
        onRemove={() => onRemove(opt.value)}
      />
    ));
};

export default CategoryFiltersTags;
